import type { Game } from '../core/game';

/**
 * Refus d'équipement expliqué au joueur — v0.26.0 (A72-14) : un seul
 * exemplaire de chaque dé Prismatique nommé équipé à la fois (« Un seul Dé
 * enragé de Guinsoo équipé à la fois »). Renvoie la phrase du cœur, ou `null`
 * quand l'équipement est permis (ou que le cœur ne sait pas encore le dire).
 */
export function equipRefusal(game: Game, dieId: string, slot: number): string | null {
  const fn = (game as unknown as { canEquipDie?: (id: string, s: number) => { ok: boolean; reason?: string } })
    .canEquipDie;
  if (typeof fn !== 'function') return null;
  const check = fn.call(game, dieId, slot);
  return check.ok ? null : (check.reason ?? 'Ce dé ne peut pas être équipé ici.');
}
